export const WF_OWNED_SITES = [
	"wellsfargo.com",
	"wf.com",
	"wellsfargoassetmanagement.com",
	"wellsfargoadvisors.com",
	"wellsfargomedia.com",
	"localhost:3000",
	// "facebook.com/wellsfargo",
	// "youtube.com/user/wellsfargo",
	// "linkedin.com/company/wellsfargo",
	// "instagram.com/wellsfargo",
	// "pinterest.com/wellsfargo",
	// "twitter.com/wellsfargo",
]

export const EXIT_OVERLAY_EXCEPTIONS = [
	"https://www.facebook.com/sharer/",
	"https://twitter.com/intent/tweet",
	"https://www.linkedin.com/sharing/share-offsite/",
	"https://www.linkedin.com/shareArticle?mini=true&url="
]